import type { TranslationMessages } from '../../types';

export const profile: TranslationMessages = {
  title: 'My Profile',
  subtitle: 'View and manage your personal profile information',
  user_not_found: 'User not found',
  profile_created: 'Staff profile created successfully',
  profile_create_failed: 'Failed to create your profile',
  profile_load_failed: 'Failed to load your profile',
  profile_deleted: 'Staff profile deleted successfully',
  duplicate_profiles_warning:
    'Warning: Found multiple profiles for this user. Updating the most recent one.',
  duplicate_profiles_detected:
    'Warning: Found multiple profiles. Please contact an administrator to merge them.',
  duplicate_profiles_error:
    'Error: User has multiple profiles. Only 1 profile per user is allowed. Please contact administrator.',
  profile_delete_failed: 'Failed to delete staff profile',
  retry: 'Retry',
  total_staff: 'Total Staff',
  active_staff_members: 'Active staff members',
  department: 'Department',
  your_department: 'Your department',
  position: 'Position',
  your_position: 'Your position',
  avg_rate: 'Avg Rate',
  average_hourly_rate: 'Average hourly rate',
  personal_information: 'Personal Information',
  user_id: 'User ID',
  address: 'Address',
  gender: 'Gender',
  not_specified: 'Not specified',
  professional_information: 'Professional Information',
  department_id: 'Department ID',
  not_assigned: 'Not assigned',
  position_id: 'Position ID',
  hourly_rate: 'Hourly Rate',
  no_profile_found: 'No Profile Found',
  profile_not_available: 'Your staff profile information is not available.',
  personal_info: 'Personal Information',
  hire_date: 'Hire Date',
  edit_profile: 'Edit Staff Profile',
  edit_profile_description:
    'Update staff profile information including employment type and compensation',
  profile_updated: 'Staff profile updated successfully',
  profile_update_failed: 'Failed to update staff profile',
  basic_information: 'Basic Information',
  address_placeholder: 'Enter address',
  gender_placeholder: 'Enter gender',
  position_id_placeholder: 'Enter position ID',
  department_id_placeholder: 'Enter department ID',
  employment_information: 'Employment Information',
  employment_type: 'Employment Type',
  part_time: 'Part-Time',
  full_time: 'Full-Time',
  contract: 'Contract',
  full_time_settings: 'Full-Time Settings',
  vacation_days_per_year: 'Vacation Days Per Year',
  vacation_days_used: 'Vacation Days Used',
  base_salary: 'Base Salary (Optional)',
  base_salary_hint: 'Monthly base salary if applicable',
  guaranteed_hours: 'Guaranteed Hours Per Week',
  guaranteed_hours_hint: 'Minimum hours guaranteed per week',
  compensation: 'Compensation',
  rate_per_hour: 'Rate Per Hour',
  currency: 'Currency',
  user_id_required: 'User ID is required to create a profile',
  current_points: 'Current Points',
  total_earned: 'Total Earned',
  total_spent: 'Total Spent',
  earned_badges: 'Earned Badges',
  badge_collection: 'Badge Collection',
  no_badges: 'No badges earned yet',
};
